
import ObjectCard from '../../components/Card/ObjectCard.vue'
import { getCustomTabsList } from './projectCardCustomTabs.js'

export default {
  name: 'ProjectCard',
  extends: ObjectCard,
  data: function () {
    return {
      typeKeyLocal: 'project', // @Override
      typeShownLocal: false
    }
  },
  methods: {
    /**
     * ObjectCard
     */
    // @Override
    setObjectType: function (objectTypeKey) {
      // ignore Иначе typeKeyLocal перезапишется
    },
    // @Override
    getRawCustomTabsList: function (config) {
      return getCustomTabsList(config)
    },
    // @Default
    checkUserAccess: function (user) {
      const access = this.getDefaultAccess()

      access.editPrivate = user.fullAccess
      access.viewPrivate = user.fullAccess
      access.viewPublic = true
      access.editPublic = user.hasRole('admin', 'dispatcher', 'reportchecker')

      access.editOrganizationProject = user.hasRole('admin')
      access.editAny = access.editPublic || access.editOrganizationProject
      return access
    }
  }
}
